import request from '@/utils/request';

//公众号列表
export function getAppIdList() {
  return request('/wechat/queryWechatAccountList', {
    method: 'GET',
    // data: values,
  });
}
//小程序列表
export function getMiniAppIdList() {
  return request('/wechat/queryWechatMiniProgramAccountList', {
    method: 'GET',
    // data: values,
  });
}
//获取等级列表
export function getLevels() {
  return request('/config/queryLevels', {
    method: 'GET',
  });
}
//区域列表
export function getRegionList() {
  return request('/region/queryRegionList', {
    method: 'GET',
  });
}
//新增抽奖活动
export function addActivityLottery(values) {
  return request('/activityLottery/addActivityLottery', {
    method: 'POST',
    data: values,
  });
}
//更新抽奖活动
export function updateActivityLottery(values) {
  return request('/activityLottery/updateActivityLottery', {
    method: 'POST',
    data: values,
  });
}
//查询单个抽奖抽奖活动
export function getActivityLotteryDetail(values) {
  return request('/activityLottery/queryActivityDetail', {
    method: 'POST',
    data: values,
  });
}

//门店
export function getStores(values) {
  return request('/store/queryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//查询奖品已发放数量
export function queryPrizeSendNum(values) {
  return request('/activityLottery/queryPrizeSendNum', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//校验奖品数量与库存
export function checkPrizeNum(values) {
  return request('/activityLottery/checkPrizeNum', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
